 
<template>
  <div id="app">
    <b-carousel
      :autoplay="false"
      :indicator="false"
      :arrow="false"
      :has-drag="false"
      v-model="carousel"
    >
      <b-carousel-item :key="0">
        <section class="hero is-success is-fullheight">
          <!-- Hero head: will stick at the top -->
          <div class="hero-head">
            <header class="navbar">
              <div class="container">
                <div class="navbar-brand">
                  <a class="navbar-item logo">
                    TATTA
                    <i class="ti-comments-smiley"></i> FON
                  </a>
                </div>
              </div>
            </header>
          </div>

          <!-- Hero content: will be in the middle -->
          <div class="hero-body">
            <div class="container has-text-centered">
              <h1 class="title">Einzahlen auf dein Karma-Konto</h1>
              <h2 class="subtitle">
                Die vollautomatisierte Tatta Hotline verbindet
                <br />Helfer und Hilfesuchende auf einfachste Weise.
              </h2>

              <b-button class="button is-medium is-primary" @click="setPage(1)">
                <i class="ti-check-box"></i> Werde ein Tatta Held
              </b-button>

              <section>
                <p>#CodeVsCovid19</p>
                <h2 class="subtitle">
                  Anrufen:
                  <a href="tel:+41525391234">052 539 1234</a>
                </h2>
              </section>
            </div>
          </div>
          <div class="hero-foot">
            <nav class="tabs">
              <div class="container">
                <ul>
                  <li @click="setPage(1)">
                    <a>Registrieren</a>
                  </li>
                  <!--<li @click="setPage(2)">
                    <a>Wer ist Tatta?</a>
                  </li>-->
                </ul>
              </div>
            </nav>
          </div>
        </section>
      </b-carousel-item>

      <b-carousel-item :key="1">
        <section class="hero is-success is-fullheight">
          <!-- Hero head: will stick at the top -->
          <div class="hero-head">
            <header class="navbar">
              <div class="container">
                <div class="navbar-brand">
                  <a class="navbar-item logo">
                    TATTA
                    <i class="ti-comments-smiley"></i> FON
                  </a>
                </div>
              </div>
            </header>
          </div>

          <!-- Hero content: will be in the middle -->
          <div class="hero-body">
            <div class="container has-text-centered">
              <h1 class="title">Jetzt als Tatta Held registrieren!</h1>
              <div class="columns is-centered has-text-left">
                <div class="box is-two-fifths">
                  <b-steps v-model="activeStep" :hasNavigation="false" :animated="isAnimated">
                    <b-step-item label="Registrieren" :clickable="false">
                      <form id="register" name="register" @submit.prevent="register">
                        <b-field label="Vorname*">
                          <b-input type="text" required v-model="vorname" name="vorname"></b-input>
                        </b-field>

                        <b-field label="Postleitzahl*">
                          <b-input
                            v-model="plz"
                            name="plz"
                            placeholder="8001"
                            type="text"
                            minlength="4"
                            maxlength="4"
                            required
                          ></b-input>
                        </b-field>

                        <b-field label="Mobilnummer (Schweiz)*">
                          <b-input
                            name="mobile"
                            v-model="mobile"
                            placeholder="0781234567"
                            type="tel"
                            minlength="10"
                            maxlength="10"
                            required
                          ></b-input>
                        </b-field>

                        <b-field label="Welche Tätigkeiten würdest du übernehmen?*">
                          <div class="field">
                            <b-checkbox v-model="einkaufen">Einkaufen</b-checkbox>
                            <br />
                            <b-checkbox v-model="abholen">Dinge Abholen</b-checkbox>
                            <br />
                            <b-checkbox v-model="arbeiten">Einfache Garten-/Reparaturarbeiten</b-checkbox>
                            <br />
                            <b-checkbox v-model="sonstiges">Sonstiges</b-checkbox>
                          </div>
                        </b-field>
                        <input class="button is-primary" type="submit" value="Werde ein Tatta Held" />
                      </form>
                    </b-step-item>
                    <b-step-item label="Verifizierung" :clickable="false">
                      <form id="register" name="validate" @submit.prevent="validate">
                        <b-field>
                          <p>
                            Wir haben einen SMS Code an die angegebene Nummer geschickt.
                            <br />Bitte gebe diesen hier ein.
                          </p>
                        </b-field>

                        <b-field label="SMS Code">
                          <b-input type="number" name="smscode" v-model="smscode" required></b-input>
                        </b-field>

                        <input
                          class="button is-primary"
                          type="submit"
                          value="Registrierung abschliessen"
                        />
                      </form>
                    </b-step-item>
                    <b-step-item label="Abschluss" :clickable="false">
                      <img src="./assets/source.gif" />
                      <div class="content is-medium">
                        <h2>WOHOO!! Danke für deine Registration!</h2>
                        <h3>Wie gehts weiter?</h3>
                        <p>Sobald wir jemandem deine Hilfe anbieten können, bekommst du seine Telefonnummer per SMS zugeschickt.</p>
                        <p>Da diese Person kein Smartphone hat, rufst du deine Tatta am besten gleich an.</p>
                        <h3>Wie ändere ich meine Einstellungen?</h3>
                        <p>Registriere dich nochmals mit deiner Telefonnummer und mache andere Einstellungen.</p>
                      </div>
                    </b-step-item>
                  </b-steps>
                </div>
              </div>
              <section>
                Wir benötigen deine
                PLZ um dich mit Hilfesuchenden aus der Umgebung zu verbinden.
                <br />Deine
                Mobilnummer dient als dein Kommunikationskanal zu den Hilfesuchenden.
              </section>
            </div>
          </div>
          <div class="hero-foot">
            <nav class="tabs">
              <div class="container">
                <ul>
                  <li @click="setPage(0)">
                    <a>
                      <i class="ti-angle-double-left"></i>
                    </a>
                  </li>
                  <li @click="setPage(1)">
                    <a>Registrieren</a>
                  </li>
                  <!--<li @click="setPage(2)">
                    <a>Wer ist Tatta?</a>
                  </li>-->
                </ul>
              </div>
            </nav>
          </div>
        </section>
      </b-carousel-item>

      <b-carousel-item :key="2">
        <section class="hero is-success is-fullheight">
          <!-- Hero head: will stick at the top -->
          <div class="hero-head">
            <header class="navbar">
              <div class="container">
                <div class="navbar-brand">
                  <a class="navbar-item logo">
                    TATTA
                    <i class="ti-comments-smiley"></i> FON
                  </a>
                </div>
              </div>
            </header>
          </div>

          <!-- Hero content: will be in the middle -->
          <div class="hero-body">
            <div class="container has-text-centered"></div>
          </div>
          <div class="hero-foot">
            <nav class="tabs">
              <div class="container">
                <ul>
                  <li @click="setPage(0)">
                    <a>
                      <i class="ti-angle-double-left"></i>
                    </a>
                  </li>
                  <li @click="setPage(1)">
                    <a>Registrieren</a>
                  </li>
                  <li @click="setPage(2)">
                    <a>Wer ist Tatta?</a>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
        </section>
      </b-carousel-item>
    </b-carousel>
  </div>
</template>


<style scoped>
@import url("https://fonts.googleapis.com/css?family=Inconsolata|Lato&display=swap");
#app,
button,
input {
  font-family: "Lato", sans-serif;
}
.button.is-primary {
  background-color: #d83f87;
}
.logo {
  font-family: "Inconsolata", monospace;
  font-size: 2.5rem;
}
.hero.is-success a.navbar-item:hover,
.hero.is-success a.navbar-item.is-active,
.hero.is-success .navbar-link:hover,
.hero.is-success .navbar-link.is-active {
  background-color: transparent;
  color: #fff;
}

.hero {
  background: rgb(42, 27, 61);
  background: linear-gradient(
    38deg,
    rgba(42, 27, 61, 1) 9%,
    rgba(68, 49, 141, 1) 59%
  );
}
.overlap {
  margin-top: -2rem;
}
.overlap .box {
  border-radius: 0%;
  border-width: 4px;
}
</style>

<script>
const apiUrl = "https://r6rdo872wa.execute-api.eu-central-1.amazonaws.com";
const registerUrl = apiUrl + "/dev/tatta/register";
const validateUrl = apiUrl + "/dev/tatta/validate";

import axios from "axios";

export default {
  data() {
    return {
      isStepsClickable: false,
      isAnimated: true,
      carousel: 0,
      activeStep: 0,
      vorname: "",
      email: "",
      plz: "",
      mobile: "",
      einkaufen: "",
      abholen: "",
      arbeiten: "",
      sonstiges: "",
      smscode: "",
      hash: ""
    };
  },
  components: {},
  methods: {
    setPage(value) {
      this.carousel = value;
    },
    register(context) {
      console.log(context);
      var params = {
        params: {
          vorname: this.vorname,
          plz: this.plz,
          email: this.email,
          mobile: this.mobile,
          einkaufen: this.einkaufen,
          abholen: this.abholen,
          arbeiten: this.arbeiten,
          sonstiges: this.sonstiges
        }
      };
      if (params.params.mobile.substr(0, 1) == "0") {
        params.params.mobile = params.params.mobile.substr(
          1,
          params.params.mobile.length
        );
      }
      axios
        .post(registerUrl, params)
        .then(response => {
          this.$buefy.toast.open({
            duration: 5000,
            message: `Cool! Wir haben eine SMS an die Nummer gesendet.`,
            type: "is-success"
          });
          this.activeStep = 1;
          this.hash = response.data.data.hash;
        })
        .catch(error => {
          this.$buefy.toast.open({
            duration: 5000,
            message: `Ein Fehler ist aufgetreten, wir konnten die Registration nicht abschliessen.`,
            type: "is-danger"
          });
          this.activeStep = 0;
          console.log(error);
        });
    },
    validate(context) {
      console.log(context);
      console.log(this.responseData);
      axios
        .post(validateUrl, {
          params: {
            hash: this.hash,
            smscode: this.smscode
          }
        })
        .then(response => {
          if (response.data.message == "no-match") {
            this.$buefy.toast.open({
              duration: 5000,
              message: `Hoppla, der SMS Code stimmt nicht überein. Bitte prüfe dies nochmals.`,
              type: "is-danger"
            });
            this.smscode = "";
          }
          if (
            response.data.message == "verified" ||
            response.data.message == "already-verified"
          ) {
            this.$buefy.toast.open({
              duration: 5000,
              message: `Du bist jetzt offiziell ein Tatta Held! Hurra!`,
              type: "is-success"
            });
            this.activeStep = 2;
            this.responseData = response.data;
          }
        })
        .catch(error => {
          this.$buefy.toast.open({
            duration: 5000,
            message: `Ein Fehler ist aufgetreten, wir konnten die Telefonnummer nicht validieren.`,
            type: "is-danger"
          });
          this.activeStep = 0;
          console.log(error);
        });
    }
  }
};
</script>